

import { ApiService } from "./api.service";
import { Router } from "@angular/router";

import { Injectable } from '@angular/core';
import { StatisticsModel } from "../models/statistics.model";
//import { Observable, of } from 'rxjs';
import { IResponse } from "@bt/shared";
import { StatisticFilterModel } from "../models/statisticFilter.model";
import { FilterElementsModel } from "../models/filterElements.model";

@Injectable()
export class StatisticsService{

    constructor(private api: ApiService,
                private router: Router,){}

    // public GetStatistics(): Promise<IResponse<StatisticsModel[]>>{
    //     return this.api.get<StatisticsModel[]>("api/statistic/getstatistic").toPromise();
    // }

    // public deleteDomain(domainModel: DomainPostRequest[]): Promise<IResponse<boolean>> {
    //     return this.api.put<boolean>("api/domains/deletedomain", domainModel).toPromise();
    //   }

    // public GetEditDomain(id:number): Promise<IResponse<DomainPostRequest>>{
    //     return this.api.get<DomainPostRequest>("api/domains/newdomain/"+id).toPromise();
    // }

    public GetStatisticNotifications(statisticFilterModel: StatisticFilterModel): Promise<IResponse<StatisticsModel[]>>{
        return this.api.post<StatisticsModel[]>("api/statistic/getstatisticnotification", statisticFilterModel).toPromise();
    }

    public GetStatisticSubscriptions(statisticFilterModel: StatisticFilterModel): Promise<IResponse<StatisticsModel[]>>{
      return this.api.post<StatisticsModel[]>("api/statistic/getstatisticsubscription", statisticFilterModel).toPromise();
    }

    public GetStatisticByDate(statisticFilterModel: StatisticFilterModel): Promise<IResponse<StatisticsModel[]>>{
        return this.api.post<StatisticsModel[]>("api/statistic/getstatisticbydate", statisticFilterModel).toPromise();
    }

    public GetFilterElements(): Promise<IResponse<FilterElementsModel>>{
        return this.api.get<FilterElementsModel>("api/statistic/getfilterelements").toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/statistics.service.ts